

































































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/prescription';
import * as resize from '@/subjects/resize';

@Component({
  components: {
    ListMessages
  }
})
export default class HistoryDetailsPrescButton extends BaseComponent {
  @Prop()
  public id;

  currentTab = 'tab-hist';

  private dto = null;
  private historicoExibindo: any[] = [];
  private historicoError: boolean = false;
  private carregandoHistorico: boolean = false;


  smallScreen: boolean = resize.isXsOrSmSizeScreen();
  menuOn = false;
  key=0;

  @Watch('menuOn')
  watchMenuOn(v) {
    this.currentTab = 'tab-hist';
  }

  public buscarHistorico(): void {
    this.historicoError = false;
    this.carregandoHistorico = true;
    this.dto = null;
    this.historicoExibindo = [];
    this.key++;      

    this.addSubsc(
      service.getHistoricoPrescricao(this.id).subscribe(
        (dto) => {
          this.carregandoHistorico = false;
          this.dto = dto;
          this.historicoExibindo = dto.historicos;
          this.key++;          
        },
        (error) => {
          this.carregandoHistorico = false;
          this.historicoError = true;
        }
      )
    );
  }
}
